import axios from 'axios';

import { CsrfApiFactory } from '@/api/generated';
import { CONFIG } from '@/config/config.ts';

const csrfApi = CsrfApiFactory(undefined, CONFIG.HOST, axios.create({ withCredentials: true }));

// The backend uses HttpSessionCsrfTokenRepository: the token is stable for the whole session and
// does not rotate per request, so it is fetched once and reused.
let cachedToken: null | string = null;
let inFlight: null | Promise<string> = null;

export const getCsrfToken = async (): Promise<string> => {
  if (cachedToken !== null) {
    return cachedToken;
  }
  inFlight ??= csrfApi
    .getCsrfToken()
    .then(({ data }) => {
      cachedToken = data.token;
      return cachedToken;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};
